import { render, staticRenderFns } from "./PFAwaitingDisbursement.vue?vue&type=template&id=0534cab2"
import script from "./PFAwaitingDisbursement.vue?vue&type=script&lang=js"
export * from "./PFAwaitingDisbursement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports